var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.005 11.289V4.69a.7.7 0 011.193-.497l3.313 3.284a.7.7 0 01.002.992L7.2 11.783a.7.7 0 01-1.195-.494z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjAwNDg4IDExLjI4ODZWNC42OTEwNkM2LjAwNDg4IDQuMDY4OTMgNi43NTU3NyAzLjc1NTk0IDcuMTk3NjQgNC4xOTM4OEwxMC41MTExIDcuNDc3OTFDMTAuNzg2NiA3Ljc1MDkxIDEwLjc4NzYgOC4xOTU4MyAxMC41MTMzIDguNDcwMDZMNy4xOTk4NiAxMS43ODM1QzYuNzU4ODggMTIuMjI0NSA2LjAwNDg4IDExLjkxMjIgNi4wMDQ4OCAxMS4yODg2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { Svg16 as ReactComponent };